











import {Component, Prop, Vue} from 'vue-property-decorator';
import {CsvValidation} from '@/helpers/csv/CsvValidation';

@Component({})
export default class CsvFileTable extends Vue {
  @Prop({default: {value: new CsvValidation()}}) readonly uploadedFileCsvValidationContainer: {value: CsvValidation};
}
